import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var RemoteImpl =
/*#__PURE__*/
function () {
  function RemoteImpl() {
    _classCallCheck(this, RemoteImpl);

    this.base = '/api';
    this.tokenListeners = [];
  }

  _createClass(RemoteImpl, [{
    key: "logout",
    value: function logout() {
      window.sessionStorage.removeItem("3skye.auth.token");
      if (this.registeredLogoutAction) this.registeredLogoutAction();
    }
  }, {
    key: "registerLogoutHandler",
    value: function registerLogoutHandler(logout) {
      this.registeredLogoutAction = logout;
    }
  }, {
    key: "registerTokenListener",
    value: function registerTokenListener(listener) {
      this.tokenListeners.push(listener);
    }
  }, {
    key: "unregisterTokenListener",
    value: function unregisterTokenListener(listener) {
      var index = this.tokenListeners.indexOf(listener);
      if (index > -1) this.tokenListeners.splice(index, 1);
    }
  }, {
    key: "handleSessionTimeout",
    value: function handleSessionTimeout() {
      this.logout();
    }
  }, {
    key: "createTokenHeader",
    value: function createTokenHeader() {
      var token = window.sessionStorage.getItem("3skye.auth.token");

      if (!token) {
        return {
          headers: {}
        };
      }

      return {
        headers: {
          "X-3Skye-Session": token
        }
      };
    }
  }, {
    key: "setToken",
    value: function setToken(resp) {
      var newToken = resp.headers.get("X-3Skye-Set-Token");

      if (newToken) {
        window.sessionStorage.setItem("3skye.auth.token", newToken);
        this.tokenListeners.forEach(function (listener) {
          return listener(newToken);
        });
      }
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(resp, options) {
      if (resp.ok) {
        this.setToken(resp);
        if (options.rawResponse) return resp;else return resp.json();
      } else {
        if (resp.status === 418 || resp.status === 401) {
          this.handleSessionTimeout();
        } else {
          //Update the user token regardless
          this.setToken(resp);
        }

        return Promise.reject(resp.status);
      }
    }
  }, {
    key: "get",
    value: function get(apiURL, options) {
      var _this = this;

      var headers = this.createTokenHeader();
      options = options || {};
      var url = this.base + apiURL;

      if (options.timeout !== null) {
        return fetch(url, headers).then(function (resp) {
          return _this.handleResponse(resp, options);
        }); //TODO handle unauthorised
      } else {
        return this.timeout(20000, fetch(url, headers)).then(function (resp) {
          return _this.handleResponse(resp, options);
        }); // .then((data)=>{
        //         handler(data);
        // }).catch(e=>{
        //         if (timeout) timeout(e);
        // });
      }
    }
  }, {
    key: "put",
    value: function put(apiURL, content, options) {
      return this.send("put", apiURL, content, options);
    }
  }, {
    key: "post",
    value: function post(apiURL, content, options) {
      return this.send("post", apiURL, content, options);
    }
  }, {
    key: "delete",
    value: function _delete(apiURL, content, options) {
      return this.send("delete", apiURL, content, options);
    }
  }, {
    key: "send",
    value: function send(method, apiURL, content, options) {
      var _this2 = this;

      var headers = this.createTokenHeader();
      options = options || {};
      var url = this.base + apiURL;
      headers.headers["Content-Type"] = "application/json; charset=utf-8";
      Object.assign(headers, {
        method: method,
        body: JSON.stringify(content),
        credentials: "include"
      });

      if (options.timeout !== null) {
        return fetch(url, headers).then(function (resp) {
          return _this2.handleResponse(resp, options);
        });
      } else {
        return this.timeout(20000, fetch(url, headers)).then(function (resp) {
          return _this2.handleResponse(resp, options);
        }); // .then((data)=>{
        //         handler(data);
        // }).catch(e=>{
        //         if (timeout) timeout(e);
        // });
      }
    }
  }, {
    key: "timeout",
    value: function timeout(millis, promise) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject(new Error("timeout"));
        }, millis);
        promise.then(resolve, reject);
      });
    }
  }]);

  return RemoteImpl;
}();

export default RemoteImpl;